import type { ReactNode } from "react";
import RegionSelector from "./RegionSelector";
import { useSession } from "../../context/session-context";

export default function RegionGate({ children }: { children: ReactNode }) {
  const { regionStatus, regionError, selectRegion } = useSession();

  // Show invalid state - block the app
  if (regionStatus === "invalid") {
    return (
      <div
        style={{
          padding: "24px",
          color: "#b00020",
        }}
      >
        <h2 style={{ marginBottom: "8px" }}>Invalid URL</h2>
        <p style={{ margin: 0 }}>{regionError}</p>
      </div>
    );
  }

  // For loading and ready states, render children (allow app to initialize)
  // Show popup overlay only when user needs to select a region (missing state)
  return (
    <>
      <RegionSelector
        open={regionStatus === "missing"}
        onSelect={selectRegion}
      />

      {/* Render children for "loading", "ready", and "missing" states to show skeleton loaders behind overlay */}
      {(regionStatus === "loading" || regionStatus === "ready" || regionStatus === "missing") && children}
    </>
  );
}